import { Icon } from "./Icons";

const dateFormatter = new Intl.DateTimeFormat("ru-RU", { day: "2-digit", month: "short" });
const timeFormatter = new Intl.DateTimeFormat("ru-RU", { hour: "2-digit", minute: "2-digit" });

function formatDate(value) {
  const date = new Date(value);
  const today = new Date();
  return date.toDateString() === today.toDateString() ? timeFormatter.format(date) : dateFormatter.format(date);
}

export default function EmailList({ data, loading, query, onQuery, onSelect, onRefresh, onPage, title = "Входящие" }) {
  const items = data?.items || [];
  const pagination = data?.pagination || { page: 1, pages: 1, total: 0 };

  return (
    <section className="mailPanel">
      <header className="panelHeader">
        <div><p className="eyebrow">MAILBOX</p><h1>{title}</h1><span>{pagination.total} писем</span></div>
        <button className="iconButton" onClick={onRefresh} title="Обновить"><Icon name="refresh" /></button>
      </header>
      <label className="searchBox">
        <Icon name="search" size={19} />
        <input value={query} onChange={(event) => onQuery(event.target.value)} placeholder="Поиск по письмам" />
      </label>
      <div className="emailRows" aria-live="polite">
        {loading && <div className="stateMessage"><span className="spinner" />Загружаем почту</div>}
        {!loading && !items.length && <div className="emptyState"><Icon name="mail" size={32} /><h2>Здесь пока тихо</h2><p>Новые письма появятся в этом списке.</p></div>}
        {!loading && items.map((email) => (
          <button key={email.id} className={`emailRow ${email.isRead ? "" : "unread"}`} onClick={() => onSelect(email.id)}>
            <span className="readDot" />
            <span className="senderAvatar">{(email.senderName || email.sender || "?").charAt(0).toUpperCase()}</span>
            <span className="emailSummary">
              <span className="emailSender">{email.senderName || email.sender}</span>
              <strong>{email.subject}</strong>
              <small>{email.preview || "Нет текстового содержимого"}</small>
            </span>
            <span className="emailMeta">
              <time>{formatDate(email.receivedAt)}</time>
              <span>{email.isTemp && <b className="tag">TEMP</b>}{email.attachmentCount > 0 && <Icon name="paperclip" size={15} />}</span>
            </span>
          </button>
        ))}
      </div>
      {pagination.pages > 1 && (
        <footer className="pagination">
          <button disabled={pagination.page <= 1} onClick={() => onPage(pagination.page - 1)}>Назад</button>
          <span>{pagination.page} / {pagination.pages}</span>
          <button disabled={pagination.page >= pagination.pages} onClick={() => onPage(pagination.page + 1)}>Далее</button>
        </footer>
      )}
    </section>
  );
}
